/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    blockquote: "blockquote",
    strong: "strong",
    code: "code",
    pre: "pre",
    h3: "h3",
    em: "em"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "引用其他组件(Referring to other components)"
    }), "\n", _jsx(_components.p, {
      children: "¥Referring to other components"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "这是一个特定于 Web 的 API，你将无法在 React-Native 中使用它。"
      }), "\n", _jsxs(_components.p, {
        children: ["¥This is a ", _jsx(_components.strong, {
          children: "web-specific"
        }), " API and you ", _jsx(_components.strong, {
          children: "won't"
        }), " be able to use it in react-native."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "有多种方法可以将上下文覆盖应用于组件的样式。话虽这么说，如果不装配众所周知的目标的 CSS 选择器范例，然后使它们可以在插值中使用，那么这一切都不容易。"
    }), "\n", _jsx(_components.p, {
      children: "¥There are many ways to apply contextual overrides to a component's styling. That being said,\nit rarely is easy without rigging up a well-known targeting CSS selector paradigm\nand then making them accessible for use in interpolations."
    }), "\n", _jsxs(_components.p, {
      children: ["styled-components 通过 \"组件选择器\" 模式干净地解决了这个用例。每当 ", _jsx(_components.code, {
        children: "styled()"
      }), " 工厂函数创建或封装组件时，它也会被分配一个稳定的 CSS 类以用于定位。这允许极其强大的组合模式，而不必为命名和避免选择器冲突而大惊小怪。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥styled-components solves this use case cleanly via the \"component selector\" pattern. Whenever\na component is created or wrapped by the ", _jsx(_components.code, {
        children: "styled()"
      }), " factory function, it is also assigned a\nstable CSS class for use in targeting. This allows for extremely powerful composition patterns\nwithout having to fuss around with naming and avoiding selector collisions."]
    }), "\n", _jsx(_components.p, {
      children: "一个实际的例子：在这里，我们的图标组件定义了它对悬停的父链接的响应："
    }), "\n", _jsx(_components.p, {
      children: "¥A practical example: here, our Icon component defines its response to the parent Link being hovered:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Link = styled.a`\n  display: flex;\n  align-items: center;\n  padding: 5px 10px;\n  background: papayawhip;\n  color: #BF4F74;\n`;\n\nconst Icon = styled.svg`\n  flex: none;\n  transition: fill 0.25s;\n  width: 48px;\n  height: 48px;\n\n  ${Link}:hover & {\n    fill: rebeccapurple;\n  }\n`;\n\nconst Label = styled.span`\n  display: flex;\n  align-items: center;\n  line-height: 1.2;\n\n  &::before {\n    content: '◀';\n    margin: 0 10px;\n  }\n`;\n\nrender(\n  <Link href=\"#\">\n    <Icon viewBox=\"0 0 20 20\">\n      <path d=\"M10 15h8c1 0 2-1 2-2V3c0-1-1-2-2-2H2C1 1 0 2 0 3v10c0 1 1 2 2 2h4v4l4-4zM5 7h2v2H5V7zm4 0h2v2H9V7zm4 0h2v2h-2V7z\"/>\n    </Icon>\n    <Label>Hovering my parent changes my style!</Label>\n  </Link>\n);\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "我们可以将颜色更改规则嵌套在 Link 组件中，但随后我们必须考虑两组规则才能理解 Icon 的行为原因。"
    }), "\n", _jsx(_components.p, {
      children: "¥We could have nested the color-changing rule within our Link component, but then we'd have to\nconsider both sets of rules to understand why Icon behaves as it does."
    }), "\n", _jsx(_components.h3, {
      children: "警告(Caveat)"
    }), "\n", _jsx(_components.p, {
      children: "¥Caveat"
    }), "\n", _jsxs(_components.p, {
      children: ["此行为仅在样式化组件的上下文中受支持：在以下示例中尝试安装 ", _jsx(_components.code, {
        children: "B"
      }), " 将失败，因为组件 ", _jsx(_components.code, {
        children: "A"
      }), " 是 ", _jsx(_components.code, {
        children: "React.Component"
      }), " 的实例而不是样式组件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This behaviour is only supported within the context of ", _jsx(_components.em, {
        children: "Styled"
      }), " Components:\nattempting to mount ", _jsx(_components.code, {
        children: "B"
      }), " in the following example will fail because component\n", _jsx(_components.code, {
        children: "A"
      }), " is an instance of ", _jsx(_components.code, {
        children: "React.Component"
      }), " not a Styled Component."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "class A extends React.Component {\n  render() {\n    return <div />\n  }\n}\n\nconst B = styled.div`\n  ${A} {\n  }\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["抛出的错误 - ", _jsx(_components.code, {
        children: "Cannot call a class as a function"
      }), " - 发生这种情况是因为样式化组件尝试将该组件作为插值函数调用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The error thrown - ", _jsx(_components.code, {
        children: "Cannot call a class as a function"
      }), " - occurs because the\nstyled component is attempting to call the component as an interpolation function."]
    }), "\n", _jsxs(_components.p, {
      children: ["然而，将 ", _jsx(_components.code, {
        children: "A"
      }), " 封装在 ", _jsx(_components.code, {
        children: "styled()"
      }), " 工厂中使其符合插值的条件 - 只需确保封装的组件沿着 ", _jsx(_components.code, {
        children: "className"
      }), " 传递即可。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥However, wrapping ", _jsx(_components.code, {
        children: "A"
      }), " in a ", _jsx(_components.code, {
        children: "styled()"
      }), " factory makes it eligible for interpolation -- just\nmake sure the wrapped component passes along ", _jsx(_components.code, {
        children: "className"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "class A extends React.Component {\n  render() {\n    return <div className={this.props.className} />\n  }\n}\n\nconst StyledA = styled(A)``\n\nconst B = styled.div`\n  ${StyledA} {\n  }\n`\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
